import { createUseStyles } from 'react-jss';

export default createUseStyles({
  overviewRoot: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  }
});
